<p *ngIf="showAlert && message !='' " [ngClass]="alertClass" style="position: relative;"  role="alert">
  <span class="d-flex justify-content-between align-items-center">
  <!-- Alert message -->
  {{ message }}
    <!-- Close icon -->
    <i class="fa fa-times" (click)="closeAlert()"></i>
  </span>
</p>